import { IResult } from '../../../ts/ServerApi/types/IResponse';
import { ISetScheduleParams } from '../../../ts/ServerApi/types/actionParams';
import { Request } from '../../../ts/ServerApi/requests/Request';

export class SetDataAccelerationTasksScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setDataAccelerationTasksSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
